import * as React from "react";
import { Settings2 } from "lucide-react";
import { FilterableCheckboxGroupDropdown, CheckboxGroup } from "@/components/FilterableCheckboxGroupDropdown";

export interface ViewColumnsDropdownProps {
	groups: CheckboxGroup[];
	onCheckedChange: (id: string, checked: boolean) => void;
	onToggleAll?: (checked: boolean) => void;
	loading?: boolean;
}

/**
 * A dropdown menu with search, grouped checkbox items, and optional select-all controls.
 */
export const ViewColumnsDropdown: React.FC<ViewColumnsDropdownProps> = ({
	groups,
	onCheckedChange,
	onToggleAll,
	loading = false,
}) => (
	<FilterableCheckboxGroupDropdown
		groups={groups}
		onCheckedChange={onCheckedChange}
		onToggleAll={onToggleAll}
		buttonContent={
			<>
				<Settings2 className="mr-2 h-4 w-4" />
				View
			</>
		}
		buttonClassName="ml-auto"
		loading={loading}
	/>
);
